import style from "app/style"
import styled, { css } from "styled-components"

export default {
    "Wrapper": styled.div`
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 60px 0;
    `,
    "ContentDiv": styled.div`
        width: fit-content;
        min-height: 960px;
        flex-grow: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 90px;
        background-color: ${({ theme }) => theme.color.white};
        padding: 80px 60px;
        border-radius: 12px;
    `,
    "LogoImg": styled.img`
        width: 200px;    
    `,

    "ElemList": styled.div`
        width: 456px;
        max-height: 470px;
        flex-grow: 1;
        display: flex;
        flex-direction: column;
        gap: 8px;
        overflow-y: auto;
    `,
    "Elem": styled.button`
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 8px;
        border: 1px solid ${({ theme }) => theme.color.grey2};
        padding: 12px;
        border-radius: 8px;

        ${({ $select }) => $select && css`
            background-color: ${({ theme }) => theme.color.grey1};
        `}

        & > p {
            width: fit-content;
            ${({ theme }) => theme.font.extra_small_bold};
            white-space: nowrap;
        }
    `,
    "ElemContent": styled.div`
        flex-grow: 1;

        & > h2 {
            ${({ theme }) => theme.font.small_bold};
            color: ${({ theme }) => theme.color.black};
            margin-bottom: 4px;
        }

        & > p {
            ${({ theme }) => theme.font.extra_small};
            color: ${({ theme }) => theme.color.black};
        }
    `,

    "ButtonDiv": styled.div`
        display: flex;
        gap: 8px;
    `,
}